import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import { TextareaAutosize } from "@mui/base/TextareaAutosize";
import { SelectA, FieldA } from "../../components/form";
import { useSelector, useDispatch } from "react-redux";
import { FormA } from "../../components/form";
import { Stack, Typography } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

const EcdReportForm = ({
  data,
  ecd,
  onSubmit,
  onChange,
  currentStatus,
  errors,
}) => {
  const [open, setOpen] = React.useState(false);
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    TaskTypes,
    Campaigns,
    Query,
    SubQuery,
    map,
  } = useSelector((state) => state.user || {});

  console.log("This is from the ecd report form, the errors are:", errors);

  useEffect(() => {
    console.log("The errors what are they mason.", errors);
  }, [errors]);

  const [formData, setFormData] = useState({ ...(ecd || {}) });

  useEffect(() => {
    if (currentStatus) {
      setFormData({ ...formData, callStatus: currentStatus });
    }
  }, [currentStatus]);

  useEffect(() => {
    if (data) {
      setFormData({ ...formData, callStatus: data.status });
    }
  }, [data]);

  useEffect(() => {
    console.log("form", ecd);

    // setting form data to empty object
    setFormData({});
    //if (ecd) {
    //  setFormData({ ...ecd });
    // console.log(ecd)
    //} else {
    // setFormData({});
    //}
  }, [ecd]);

  // this won't cause infinite loop, because the form data is being saved locally in this component,
  // in the view js there is also form data, with the same name, so we call onChange from the parent that updates the parent
  // formdata state
  useEffect(() => {
    console.log("formData", formData);
    onChange(formData);
  }, [formData]);

  const handleSubmit = () => {
    // console.log("data", formData);
    onSubmit(formData);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const call_status = [
    // "Completed",
    "No answer",
    "Call done",
    "Busy",
    "No network",
    "Invalid",
    "Incoming not available",
    "Not in the portal",
    "Miscarriage",
    "Call Incomplete",
    "Deceased Child",
    "Switched off",
    "Wrong number",
    "Declined",
    "Out of service",
    "Language Barrier",
    "Deceased Mother",
    "Deceased (Mother and Child)",
    "Duplicate Mother Id",
    "Not Pregnant",
    "Schedule Later",
    "Child Above 2 Years"
  ];

  const connectedStatus = [
    // "Completed",
    "Call done",
    "Not in the portal",
    "Miscarriage",
    "Call Incomplete",
    "Deceased Child",
    "Language Barrier",
    "Deceased Mother",
    "Deceased (Mother and Child)",
    "Duplicate Mother Id",
    "Not Pregnant",
    "Child Above 2 Years",
    "Schedule Later",
  ];

  const noConnectedstatus = [
    "No answer",
    "Busy",
    "No network",
    "Invalid",
    "Incoming not available",
    "Not in the portal",
    "Switched off",
    "Wrong number",
    "Declined",
    "Out of service",
    "Duplicate Mother Id",
  ];

  const pregnancy_month = [
    "Delivered",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
  ];
  const trimester_cound = ["Delivered", "One", "Two", "Three", "Four"];

  return (
    <React.Fragment>
      <Box sx={{ mb: 2, display: "flex", justifyContent: "space-between" }}>
        <Typography variant="p" sx={{ color: "#375674", fontSize: "1.5em" }}>
          {" "}
          ECD Form
        </Typography>
        {/* <button className='btn btn-success' onClick={()=>{handleSubmit(formData)}}>Save Report</button> */}
      </Box>

      <div className="row">
        <div className="col-md-4 mb-3">
          <TextField
            select
            label="Connectivity Status"
            // defaultValue="Call done"
            InputLabelProps={{
              shrink: true,
            }}
            margin="dense"
            size="small"
            fullWidth
            name="connectivityStatus"
            // disabled={data.inbound}
            value={formData.connectivityStatus || ""}
            onChange={(e) => {
              setFormData({ ...formData, connectivityStatus: e.target.value });
            }}
            // custom error logic
            error={errors.connectivityStatus}
            helperText={errors.connectivityStatus}
          >
            {["Connected", ...(!data.inbound ? ["Not Connected"] : ["Not Connected"])].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </div>
        {formData.connectivityStatus && (
          <div className="col-md-4 mb-3">
            <TextField
              select
              label="Call Status"
              InputLabelProps={{
                shrink: true,
              }}
              // disabled={data.inbound}
              margin="dense"
              size="small"
              fullWidth
              name="callStatus"
              value={formData.callStatus || ""}
              onChange={(e) => {
                // check for connected status
                if (
                  formData.connectivityStatus === "Connected" &&
                  (e.target.value === "Not in the portal" ||
                    e.target.value === "Call Incomplete")
                ) {
                  // try to change the form data now
                  setFormData((prev) => ({
                    ...prev,
                    callStatus: e.target.value,
                    cluster: "NA",
                    callerType: "NA",
                    pregnancyStatus: "NA",
                    ICDSSchemeStatus: "NA",
                  }));
                } else {
                  setFormData({
                    ...formData,
                    callStatus: e.target.value,
                    ...(e.target.value == "completed"
                      ? { cycleCompleted: true }
                      : {}),
                  }); //Very impo
                }
              }}
              // custom error logic
              error={errors.callStatus}
              helperText={errors.callStatus}
            >
              {(formData.connectivityStatus == "Connected"
                ? connectedStatus
                : formData.connectivityStatus == "Not Connected"
                  ? noConnectedstatus
                  : call_status
              ).map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </div>
        )}

        {formData.connectivityStatus == "Connected" &&
          formData.callStatus != "Language Barrier" &&
          formData.callStatus != "Schedule Later" && (
            <>
              <div className="col-md-4 mb-3">
                <TextField
                  type="text"
                  margin="dense"
                  label={"Alternate Number"}
                  value={formData.alternateNumber || ""}
                  name={"week"}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      alternateNumber: e.target.value,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  min={1}
                  fullWidth
                  size="small"
                  variant="outlined"
                // onChange={(e) => { onChange(name, e.target.value, false, index) }}
                />
              </div>

              {/* <div className="col-md-4 mb-3">
                <TextField
                  select
                  label={"Cluster"}
                  // defaultValue="Call done"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="dense"
                  size="small"
                  fullWidth
                  value={formData.clusterId || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, clusterId: e.target.value, cluster: map.Languages[e.target.value]?.name })
                  }
                  // custom error logic
                  error={errors.cluster}
                  helperText={errors.cluster}
                >
                  {Languages.map((option) => (
                    <MenuItem key={option.name} value={option._id}>
                      {option.name}
                    </MenuItem>
                  ))}
                  <MenuItem key={"NA"} value={"NA"}>
                    NA
                  </MenuItem>
                </TextField>
              </div> */}

              {/* <div className="col-md-4">
                <TextField
                  select
                  label="Data Type"
                  // defaultValue="Call done"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={data.inbound}
                  margin="dense"
                  name="dataType"
                  size="small"
                  fullWidth
                  value={formData.dataType || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, dataType: e.target.value })
                  }
                  // custom error logic
                  error={errors.dataType}
                  helperText={errors.dataType}
                >
                  {["Follow-ups", "New Data", "Inbound"].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </div> */}

              <div className="col-md-4 mb-3">
                <TextField
                  select
                  label="Caller Type"
                  // defaultValue="Institutional Delivery"
                  margin="dense"
                  size="small"
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={formData.callerType || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, callerType: e.target.value })
                  }
                  // custom error logic
                  error={errors.callerType}
                  helperText={errors.callerType}
                >
                  {["ASHA", "Mother", "Other", "NA"].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              {/* <div className="col-md-4 mb-3">
                <TextField
                  margin="dense"
                  label={"Age"}
                  type="number"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={formData.age || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, age: e.target.value })
                  }
                  // custom error logic
                  error={errors.age}
                  helperText={errors.age}
                />
              </div> */}

              <div className="col-md-4 mb-3">
                <TextField
                  select
                  label="Pregnancy Status"
                  // defaultValue="Outbound"
                  margin="dense"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  fullWidth
                  value={formData.pregnancyStatus || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      pregnancyStatus: e.target.value,
                    })
                  }
                  // custom error logic
                  error={errors.pregnancyStatus}
                  helperText={errors.pregnancyStatus}
                >
                  {["Currently Expecting", "Delivered", "NA"].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-4 mb-3">
                <TextField
                  select
                  label="ICDS Scheme Status"
                  // defaultValue="Outbound"
                  margin="dense"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  fullWidth
                  value={formData.ICDSSchemeStatus || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      ICDSSchemeStatus: e.target.value,
                    })
                  }
                  // custom error logic
                  error={errors.ICDSSchemeStatus}
                  helperText={errors.ICDSSchemeStatus}
                >
                  {[
                    "Received only eggs",
                    "Received other foods (excluding eggs)",
                    "Received both eggs and other foods",
                    "Did not received anything",
                    "No ICDS centre available in the area",
                    "Not yet registered under the ICDS Scheme",
                    "No information available",
                    "Not availed",
                    "Not satisfactory food quality",
                    "NA",
                  ].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              {/* if expecting  */}


              {formData.pregnancyStatus === "Currently Expecting" ? (
                <>
                  <div className="col-md-4">
                    <TextField
                      select
                      label="Pregnancy in month"
                      // defaultValue="One"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      margin="dense"
                      size="small"
                      fullWidth
                      name="pregnancyMonth"
                      value={formData.pregnancyMonth || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          pregnancyMonth: e.target.value,
                        })
                      }
                      error={errors.pregnancyStatus_month}
                      helperText={errors.pregnancyStatus_month}
                    >
                      {pregnancy_month.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                      <MenuItem key={"NA"} value={"NA"}>
                        NA
                      </MenuItem>
                    </TextField>
                  </div>

                  <div className="col-md-4 mb-3">
                    <TextField
                      type="number"
                      margin="dense"
                      label={"Week"}
                      value={formData.week || ""}
                      name={"week"}
                      onChange={(e) =>
                        setFormData({ ...formData, week: e.target.value })
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      min={1}
                      fullWidth
                      size="small"
                      variant="outlined"
                      error={errors.pregnancyStatus_week}
                      helperText={errors.pregnancyStatus_week}
                    // onChange={(e) => { onChange(name, e.target.value, false, index) }}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <TextField
                      select
                      label="Trimester of Pregnancy"
                      // defaultValue="Call done"
                      margin="dense"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      value={formData.trimester || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, trimester: e.target.value })
                      }
                      error={errors.pregnancyStatus_trimester}
                      helperText={errors.pregnancyStatus_trimester}
                    >
                      {trimester_cound.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>

                  <div className="col-md-4 mb-3">
                    <TextField
                      select
                      label="Is the pregnancy a high risk?"
                      // defaultValue="Institutional Delivery"
                      margin="dense"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      value={formData.highRisk || ""}
                      onChange={(e) =>
                        setFormData({ ...formData, highRisk: e.target.value })
                      }
                      error={errors.pregnancyStatus_highRisk}
                      helperText={errors.pregnancyStatus_highRisk}
                    >
                      {["Yes", "No"].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                </>
              ) : formData.pregnancyStatus === "Delivered" ? (
                <>
                  <div className="col-md-4 mb-3">
                    <TextField
                      select
                      label="Place of Child being Delivered"
                      // defaultValue="Institutional Delivery"
                      margin="dense"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      fullWidth
                      value={formData.childDeliveryPlace || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          childDeliveryPlace: e.target.value,
                        })
                      }
                      error={errors.pregnancyStatus_childDeliveryPlace}
                      helperText={errors.pregnancyStatus_childDeliveryPlace}
                    >
                      {[
                        "Institutional Delivery",
                        "Deliveries at home",
                        "Deceased Child",
                      ].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>

                  {formData.childDeliveryPlace === "Deliveries at home" && (
                    <div className="col-md-12 mb-3">
                      <TextField
                        margin="dense"
                        label={"If Delivered at home, what was the reason ?"}
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={formData.homeDeliverReason || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            homeDeliverReason: e.target.value,
                          })
                        }
                        error={errors.pregnancyStatus_homeDeliverReason}
                        helperText={errors.pregnancyStatus_homeDeliverReason}
                      />
                    </div>
                  )}

                  <div className="col-md-4 mb-3">
                    <TextField
                      select
                      label="Children under 1 year"
                      // defaultValue="Institutional Delivery"
                      margin="dense"
                      size="small"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={formData.lessThen1Year || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          lessThen1Year: e.target.value,
                        })
                      }
                      error={errors.pregnancyStatus_lessThen1Year}
                      helperText={errors.pregnancyStatus_lessThen1Year}
                    >
                      {["Yes", "No"].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                  <div className="col-md-4 mb-3">
                    <TextField
                      select
                      label="Child from 1 - 2 Year old?"
                      // defaultValue="Institutional Delivery"
                      margin="dense"
                      size="small"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={formData.between1And2 || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          between1And2: e.target.value,
                        })
                      }
                      error={errors.pregnancyStatus_between1And2}
                      helperText={errors.pregnancyStatus_between1And2}
                    >
                      {["Yes", "No"].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>

                  <div className="col-md-4 mb-3">
                    <TextField
                      select
                      label="Has the child been immunized?"
                      // defaultValue="Institutional Delivery"
                      margin="dense"
                      size="small"
                      fullWidth
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={formData.childImmunization || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          childImmunization: e.target.value,
                        })
                      }
                      error={errors.pregnancyStatus_childImmunization}
                      helperText={errors.pregnancyStatus_childImmunization}
                    >
                      {["Yes", "No", "Deceased Child"].map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>

                  {formData.childImmunization === "No" && (
                    <div className="col-md-12 mb-3">
                      <TextField
                        margin="dense"
                        label={
                          "If the child has not been immunized, what was the reason?"
                        }
                        type="text"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={formData.nonImmunizedReason || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            nonImmunizedReason: e.target.value,
                          })
                        }
                        error={errors.pregnancyStatus_nonImmunizedReason}
                        helperText={errors.pregnancyStatus_nonImmunizedReason}
                      />
                    </div>
                  )}
                </>
              ) : (
                <></>
              )}

              {/* {
                data.inbound&&
                <>
                <div className="col-md-4 mb-3">
                <FieldA
                  field= {
                    {
                      type: 'select',
                      label: 'Query',
                      option: { key: 'Query', value: '_id', label: 'name' },
                      required: true,
                      name: 'query',
                  }
                  }
                  data={{
                    Query
                  }}
                  onChange={(name, value, multiple) => {
                    formData[name] = value
                    setFormData({ ...formData })
                }}
                  value={formData.query || ""}
                  state={formData}
                />
               
              </div>
              {
                formData.query&&
                <div className="col-md-4 mb-3">
                  <FieldA
                  field= {
                    {
                      type: 'select',
                      label: 'SubQuery',
                      option: { key: 'SubQuery', value: '_id', label: 'name' },
                      required: true,
                      name: 'subquery',
                  }
                  }
                  data={{
                    SubQuery: SubQuery.filter(e=>e.query==formData.query)
                  }}
                  onChange={(name, value, multiple) => {
                    formData[name] = value
                    setFormData({ ...formData })
                }}
                  value={formData.subquery || ""}
                  state={formData}
                />
               
              </div>
              }
              
                </>
              } */}

              <div className="col-md-4 mb-3">
                <TextField
                  select
                  label="Call Score"
                  // defaultValue="Call done"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="dense"
                  name="callScore"
                  size="small"
                  fullWidth
                  value={formData.callScore || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      callScore: e.target.value,
                      ...(e.target.value == "Nil"
                        ? { notScoringReason: null }
                        : {}),
                    })
                  }
                  // custom error logic
                  error={errors.callScore}
                  helperText={errors.callScore}
                // error={errors.dataType}
                // helperText={errors.dataType}
                >
                  {["Nil", 1, 2, 3, 4, 5].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              {(!formData.callScore || formData.callScore == "Nil") && (
                <div className="col-md-8 mb-3">
                  <TextField
                    select
                    label="Not scoring reasons"
                    // defaultValue="Call done"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="dense"
                    name="notScoringReason"
                    size="small"
                    fullWidth
                    value={formData.notScoringReason || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        notScoringReason: e.target.value,
                      })
                    }
                    error={errors.notScoringReason}
                    helperText={errors.notScoringReason}
                  // custom error logic
                  // error={errors.dataType}
                  // helperText={errors.dataType}
                  >
                    {[
                      "Beneficiary did not understand the rating system after explanation",
                      "Beneficiary does not want to give a rating",
                      "Beneficiary disconnects the call before explanation of rating",
                      "Beneficiary disconnects the call after explanation of rating",
                      "Call done with ASHA/ ANM/ AW",
                      "Cannot explain in Hindi",
                      "Deceased (Mother and Child)",
                      "Deceased Child",
                      "Deceased Mother",
                      "Currently Hospitalized",
                      "Miscarriage",
                      "Not pregnant",
                    ].map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              )}

              {/* <div className="col-md-12 mb-3">
                <TextareaAutosize
                  className="col-12"
                  margin="dense"
                  minRows={10}
                  aria-label="empty textarea"
                  label="Advice"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  placeholder="Write Advice here"
                  value={formData.advice || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, advice: e.target.value })
                  }
                />
              </div> */}
            </>
          )}

        {formData.connectivityStatus == "Connected" &&
          formData.callStatus == "Schedule Later" && (
            <div className="col-md-12 mb-3">
              <div style={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
                <TextField
                  select
                  label="Scheduled Later Reason"
                  value={formData.scheduledLaterReason || ""}
                  onChange={(e) =>
                    setFormData({ ...formData, scheduledLaterReason: e.target.value })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                  margin="dense"
                  size="small"
                  fullWidth
                >
                  <MenuItem value="Client Request">Client Request</MenuItem>
                </TextField>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Scheduled Date"
                    value={formData.scheduledDate ? dayjs(formData.scheduledDate) : null}
                    onChange={(newValue) =>
                      setFormData({ ...formData, scheduledDate: newValue ? newValue.format('YYYY-MM-DD') : null })
                    }
                    minDate={dayjs()}
                    maxDate={dayjs().add(5, 'day')}
                    renderInput={(params) => (
                      <Stack direction={"column"} gap={1}>
                        <TextField
                          {...params}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          margin="dense"
                          size="small"
                          fullWidth
                          error={errors.scheduledDate}
                          helperText={errors.scheduledDate}
                        />

                      </Stack>
                    )}
                  />
                  <span>
                    {errors.scheduledDate && <span style={{ color: 'red' }}>{errors.scheduledDate}</span>}
                  </span>
                </LocalizationProvider>
              </div>
            </div>
          )}

        {/* For the inbound call save 3 new options
        * 1. Inbound 
        * 2. Inbound Callback
        */}
        {data.inbound && (
          <div className="col-md-12 mb-3">
            <TextField
              select
              label="Inbound Call Type"
              fullWidth
              margin="dense"
              size="small"
              name="inboundCallType"
              value={formData.inboundCallType || ""}
              onChange={(e) => {
                // check for connected status
                setFormData((prev) => ({
                  ...prev,
                  inboundCallType: e.target.value,
                }));
              }}
              error={errors.inboundCallType}
              helperText={errors.inboundCallType}
            >
              <MenuItem value="Inbound">Inbound</MenuItem>
              <MenuItem value="Inbound Callback">Inbound Callback</MenuItem>
              <MenuItem value="ECD Escalated Case">ECD Escalated Case</MenuItem>
            </TextField>
          </div>
        )}

        <div className="col-md-12 text-center">
          {/* <button className='btn btn-success' onClick={()=>{handleSubmit(formData)}}>Save Report</button> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default EcdReportForm;
